var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-r d-align-end items"},_vm._l((_vm.labelsToRender),function(item,index){return _c('div',{key:index,staticClass:"d-flex d-flex-r item"},[_c('label',[_vm._v(_vm._s(item.label))]),_c('span',[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }